import React from "react";

/** Status badge in the app's style. level: crit | warn | ok | info | mute */
export default function Tag({ level = "mute", children }) {
  return <span className={`ia-badge ia-badge--${level}`}>{children}</span>;
}
